import React, { useEffect, useState } from "react";
import moment from "moment";
import { useParams, useSearchParams } from "react-router-dom";

import {NotificationFilterListAPI} from "./../../API/Team/NotificationAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";


const NotificationFilterDataList = () =>{

    const {filtertype} = useParams();
    const [searchParam] = useSearchParams();

    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    
    const perpagedata = 15;

    const filterparams = new URLSearchParams();


    useEffect(() => {

        if(searchParam !== "" && searchParam !== null)
        {
            if(searchParam.get('filter_campaignid') !== "" && searchParam.get('filter_campaignid') !== null)
            {
                filterparams.append('filter_campaignid', searchParam.get('filter_campaignid'));
            }

            if(searchParam.get('filter_callerid') !== "" && searchParam.get('filter_callerid') !== null)
            {
                filterparams.append('filter_callerid', searchParam.get('filter_callerid'));
            }

            if(searchParam.get('filter_startdate') !== "" && searchParam.get('filter_startdate') !== null)
            {
                filterparams.append('filter_startdate', searchParam.get('filter_startdate'));
            }

            if(searchParam.get('filter_enddate') !== "" && searchParam.get('filter_enddate') !== null)
            {
                filterparams.append('filter_enddate', searchParam.get('filter_enddate'));
            }

            if(currentPage)
            {
                filterparams.append('page', currentPage);
            }

            if(perpagedata)
            {
                filterparams.append('per_page', perpagedata);
            }
        }

        NotificationFilterListAPI(setNotifications, setLoading, currentPage, perpagedata, setPageCount, filtertype, filterparams);

        //console.log('>>>>'+usersList);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    {filtertype === 'today' ?
                                        <h4 className="page-title">Follow Up for Today</h4>
                                    :
                                        (filtertype === 'pending' ?
                                            <h4 className="page-title">Pending Follow Ups</h4>
                                        :
                                            <h4 className="page-title">Follow Up</h4>
                                        )
                                    }
                                    
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">

                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Lead Name</th>
                                                <th>Contact</th>
                                                <th>Program</th>
                                                <th>Institute</th>
                                                <th>Caller</th>
                                                <th>Schedule Date & Time</th>                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="6">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (notifications && notifications.length > 0  ? 
                                                ( notifications.map(notification => 
                                                    (
                                            
                                                        <tr key={notification.id}>
                                                            <td>{notification.name}</td>
                                                            <td>{notification.contact}</td>
                                                            <td>{notification.program}</td>
                                                            <td>{notification.institute}</td>
                                                            <td>{notification.callername}</td>
                                                            <td>{moment(notification.display_date).format('DD-MM-YYYY')} {notification.display_time}</td>
                                                            
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="6">
                                                        <center>No record found...</center>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="row pagination-section">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>

    </div>
    )
}

export default NotificationFilterDataList;